import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

import { ServiceDefinitionListComponent } from './service-definition-list.component';
import { ServiceDefinitionItemComponentModule } from './service-definition-item/service-definition-item.module';
import { SharedModule } from '../../shared.module';

@NgModule({
    declarations: [
        ServiceDefinitionListComponent,
    ],
    imports: [
        IonicModule,
        SharedModule,
        CommonModule,
        ServiceDefinitionItemComponentModule
    ],
    exports: [
        ServiceDefinitionListComponent,
    ],
    providers: []
})
export class ServiceDefinitionListModule {}
